module.exports = __webpack_public_path__ + "static/media/StanGetz.7ce8b2ab.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/Center/Block/img/StanGetz.jpeg
// module id = 630
// module chunks = 0